import '../views/filters';

window.news = new (function (){
    this.index = function(){
      window.filters.init();
      window.filters.ajax();
   
    }
    this.details = function(){
   
    }
    
  });
  
  
   